import { SET_MANAGED_SERVICE } from '../constants/user.constants'
import { createReducer } from '@reduxjs/toolkit'

const initialState = { managedService: null }

export default createReducer(initialState, {
    [SET_MANAGED_SERVICE]: (state, action) => {
        state.managedService = action.payload
    },
})
